import constants from 'constants/ui.js';
import localPersistenceHelper from 'helpers/localPersistenceHelper.js';

const initialState = {
  masqueradeMode: null,
  masqueradeModeSettings: null,
  numberIndicators: {},
};

export default () => {
  const persistedMasqueradeMode = getState(constants.MASQUERADE_MODE_STATE_KEY);
  if (persistedMasqueradeMode !== null) {
    initialState.masqueradeMode = persistedMasqueradeMode;
  }

  return (state = initialState, { type, payload }) => {
    switch (type) {
      case constants.MASQUERADE_MODE_SET_OR_UPDATE:
        persistState(constants.MASQUERADE_MODE_STATE_KEY, payload);
        return { ...state, masqueradeMode: payload };
      case constants.MASQUERADE_MODE_UNSET:
        removeState(constants.MASQUERADE_MODE_STATE_KEY);
        return { ...state, masqueradeMode: null };
      case constants.MASQUERADE_MODE_SETTINGS_SET:
        return { ...state, masqueradeModeSettings: payload };
      case constants.MASQUERADE_MODE_SETTINGS_UNSET:
        return { ...state, masqueradeModeSettings: null };
      case constants.NUMBER_INDICATOR_SET_OR_UPDATE:
        return {
          ...state,
          numberIndicators: {
            ...state.numberIndicators,
            [payload.key]: payload.value,
          },
        };
      default:
        return state;
    }
  };
};

const persistState = (key, value) => {
  try {
    localPersistenceHelper.setItem({
      key,
      data: value,
      storage: localPersistenceHelper.storages.SESSION_STORAGE,
    });
  } catch (e) {
    console.warn(`Error: could not set key "${key}" in sessionStorage: ${e}`);
  }
};

const getState = key => {
  const serialized = localPersistenceHelper.getItem({
    key,
    storage: localPersistenceHelper.storages.SESSION_STORAGE,
  });

  if (typeof serialized === 'undefined') {
    return null;
  }

  try {
    return serialized;
  } catch (e) {
    console.warn(`Error: could not get key "${key}" in sessionStorage: ${e}`);
    return null;
  }
};

const removeState = key => {
  try {
    localPersistenceHelper.removeItem({
      key,
      storage: localPersistenceHelper.storages.SESSION_STORAGE,
    });
  } catch (e) {
    console.warn(`Error: could not remove key "${key}" in sessionStorage: ${e}`);
  }
};
